import once from 'lodash/once'
riot.tag2('autocomplete', '  <div class="input-group">\n    <input class="{&quot;open&quot;: isOpen &amp;&amp; !opts.disabled}" type="text" onfocus="{focus}" oninput="{filterOptions}" onchange="{stop}" value="{filterValue}">\n    <div class="results" show="{isOpen &amp;&amp; !opts.disabled}" onchange="return false;">\n      <div class="text" if="{parseInt(opts.minSymbols) ? filterValue.length &lt; parseInt(opts.minSymbols) : false}">Введите не менее {parseInt(opts.minSymbols)} символ{parseInt(opts.minSymbols) == 1 ? \'а\' : \'ов\'}</div>\n      <ul if="{parseInt(opts.minSymbols) ? filterValue.length &gt; (parseInt(opts.minSymbols) - 1) : true}">\n        <li each="{item, i in filter()}" onclick="{itemClick}" no-reorder>\n          <yield></yield>\n        </li>\n      </ul>\n    </div>\n    <div class="input-group-btn" if="{opts.add}">\n      <button class="btn btn-secondary" onclick="{opts.add}"><i class="fa fa-plus" title="Добавить"></i></button>\n    </div>\n  </div>\n', 'autocomplete,[riot-tag="autocomplete"],[data-is="autocomplete"]{ display: block; width: 100%; vertical-align: middle; height: 34px; position: relative; } autocomplete > input,[riot-tag="autocomplete"] > input,[data-is="autocomplete"] > input{ padding: 6px 12px; font-size: 14px; border: 1px solid #ccc; border-radius: 4px; background-color: #fff; } autocomplete .text,[riot-tag="autocomplete"] .text,[data-is="autocomplete"] .text{ margin: 6px 12px; font-size: 14px; background-color: #fff; } autocomplete > input.open,[riot-tag="autocomplete"] > input.open,[data-is="autocomplete"] > input.open{ border: 1px solid #66afe9; border-radius: 4px 4px 0 0; outline: 0; -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6); box-shadow: inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6); } autocomplete .results,[riot-tag="autocomplete"] .results,[data-is="autocomplete"] .results{ outline: 0; -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6); box-shadow: inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6); border-radius: 0 0 4px 4px; z-index: 10; position: absolute; background-color: #fff; background-image: none; border-left: 1px solid #66afe9; border-right: 1px solid #66afe9; border-bottom: 1px solid #66afe9; left: 0; right: 0; width: calc(100% - 40px); } autocomplete .results > .text,[riot-tag="autocomplete"] .results > .text,[data-is="autocomplete"] .results > .text{ display: block; position: relative; padding: 4px; } autocomplete .results > .text input,[riot-tag="autocomplete"] .results > .text input,[data-is="autocomplete"] .results > .text input{ border: 1px solid #ccc; width: 100%; padding: 4px; height: 28px; } autocomplete ul,[riot-tag="autocomplete"] ul,[data-is="autocomplete"] ul{ list-style: none; margin: 0; padding: 6px 0px; font-size: 14px; overflow-x: hidden; overflow-y: auto; max-height: 200px; } autocomplete ul li,[riot-tag="autocomplete"] ul li,[data-is="autocomplete"] ul li{ padding: 4px 12px; cursor: pointer; } autocomplete ul li:hover,[riot-tag="autocomplete"] ul li:hover,[data-is="autocomplete"] ul li:hover{ color: #fff; background-color: #66afe9; } .form-inline autocomplete,.form-inline [riot-tag="autocomplete"],.form-inline [data-is="autocomplete"]{ display: inline-block; width: auto; vertical-align: middle; }', '', function(opts) {
'use strict';

var _this = this;

var self = this;
self.filterValue = '';

self.value = opts.value;

Object.defineProperty(self.root, 'value', {
    get: function get() {
        return self.value;
    },
    set: function set(value) {
        self.value = value;
        self.update();
    }
});

var handleClickOutside = function handleClickOutside(e) {
    if (!self.root.contains(e.target)) self.close();
    self.update();
};

self.stop = function (e) {
    e.stopPropagation();
};

self.open = function () {
    self.isOpen = true;
    self.trigger('open');
};

self.close = function () {
    self.isOpen = false;
    self.trigger('close');
};

self.focus = function (e) {
    self.open();
};

self.filterOptions = function (e) {
    e.stopPropagation();
    if (e.target.value == '') {
        self.value = undefined;
        var event = document.createEvent('Event');
        event.initEvent('change', true, true);
        self.root.dispatchEvent(event);
    }
    self.filterValue = e.target.value;
};

self.filter = function () {
    var value = self.filterValue;

    if (parseInt(opts.minSymbols)) if (value.length < parseInt(opts.minSymbols)) return [];else if (value == '') return self.data;

    return self.data.filter(function (item) {
        return item[self.valueField].toLowerCase().indexOf(value.toLowerCase()) !== -1;
    });
};

self.itemClick = function (e) {
    self.value = e.item.item[self.idField];
    self.filterValue = e.item.item[self.valueField];
    self.close();
    var event = document.createEvent('Event');
    event.initEvent('change', true, true);
    self.root.dispatchEvent(event);
};

self.one('mount', function () {
    self.root.name = opts.name;
    self.close();
    document.addEventListener('mousedown', handleClickOutside);
});

self.one('update', function () {
    if (opts.loadData) self.firstLoadData = once(opts.loadData.bind(_this));
});

this.on('unmount', function () {
    document.removeEventListener('mousedown', handleClickOutside);
});

self.on('update', function () {
    if (!opts.disabled) {
        if (opts.loadData) self.loadData = opts.loadData.bind(_this);

        if (opts.data && !opts.loadData) self.data = opts.data || [];

        self.idField = opts.idField || 'id';
        self.valueField = opts.valueField || 'value';

        if (opts.loadData) self.firstLoadData();
    }
});

self.on('open', function () {
    if (self.loadData && !opts.disabled) self.loadData();
});
});


// WEBPACK FOOTER //
// ./components/autocomplete.tag